import { NgModule } from '@angular/core';
import { PrComparaisonV2Component } from './pr-comparaison-v2.component';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrValueModule } from '../pr-value/pr-value.module';
import { CommonModule } from '@angular/common';
import { PrSwiperModule } from '../pr-swiper/pr-swiper.module';
import { PrLabelModule } from '../pr-label/pr-label.module';

@NgModule({
  declarations: [PrComparaisonV2Component],
  imports: [
    CommonModule,
    PrIconModule,
    PrValueModule,
    PrLabelModule,
    PrSwiperModule,
  ],
  exports: [PrComparaisonV2Component],
})
export class PrComparaisonV2Module {}
